import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import {AuthService} from './auth.service';

@Injectable()
export class RoleGuardService implements CanActivate {

    constructor(public auth: AuthService, public router: Router) { }
  
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean{
        if (this.auth.isAuthenticated()){
            return true;    
        }
        
        this.router.navigate(['/auth']);
        return false;
    }

}


// WEBPACK FOOTER //
// ./src/app/services/role-guard.service.ts